import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { takeUntil, finalize, Subject } from 'rxjs';
import Swal from 'sweetalert2';
import { RestClientService } from 'src/app/_core/services/rest-client.service';
import { UtilitiesService } from 'src/app/_core/services/utilities.service';
import { SessionService } from 'src/app/shared/services/sessionStorage.service';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, AfterViewInit {
  private destroy$ = new Subject<void>();
  @ViewChild('canvas') canvasEl!: ElementRef<HTMLCanvasElement>;
  
  public isSeanceMultiple: boolean = false;
  // Stepper
  currentStep = 1;
  public hasValidLocation = false;
  loading = false;
  private ctx!: CanvasRenderingContext2D;
  private isDrawing = false;
  public signatureDataURL: string | null = null;
  public hasSignature = false;
  public inscriptionForm!: FormGroup;
  showConfidentialitePopup: boolean = false;
confidentialiteAcceptee: boolean = false;
isLoading = false
seances: any[] =[]
reunionInfo: any = {};
  public seanceReference: string | null = null;
  totalItems: number = 0;
  submitting: boolean = false;
  private signatureImage: HTMLImageElement | null = null;
  
  constructor(
    private fb: FormBuilder, 
    private restClient: RestClientService,
    private utilitiesService: UtilitiesService,
    private localStorage: SessionService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,

  private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.inscriptionForm = this.fb.group({
      prenoms: ['', Validators.required],
      nom: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      fonction: ['', [Validators.required]],
      societe: ['',[Validators.required]],
      telephone: ['', [Validators.required, Validators.pattern(/^[0-9]*$/)]],
      longitudePresence: [null], 
  latitudePresence: [null] 
    });
    
    this.checkForSeanceReference();
    
    this.getUserLocation();
    this.requestLocationWithRetry();
    
  }
  openConfidentialitePopup() {
    this.showConfidentialitePopup = true;
  }
  
  closeConfidentialitePopup() {
    this.showConfidentialitePopup = false;
  }
  getOrdreJourForSpecificSeance(referenceSeance: string) {
    const request = {
      user: 4,
      data: {
        referenceSeance: referenceSeance
      }
    };
    
    this.restClient
      .post('ordre-du-jour/getByCriteria', request)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.cdr.markForCheck();
        })
      )
      .subscribe({
        next: (res: any) => {
          console.log('Réponse API Ordre du jour:', res);
          
          if (res?.items?.length > 0) {
            // Stocker les éléments de l'ordre du jour
            this.seances = res.items;
            this.totalItems = res.count || res.items.length;
          } else {
            this.seances = [];
            this.totalItems = 0;
          }
        },
        error: (err) => {
          console.error('Erreur lors de la récupération de l\'ordre du jour:', err);
          this.seances = [];
          this.totalItems = 0;
        },
      });
  }
   

  ngAfterViewInit() {
    if (this.currentStep === 4) {
      setTimeout(() => {
        this.setupCanvas();
      }, 0);
    }
  }
  formatDescription(description: string | null | undefined): SafeHtml {
    if (!description) return this.sanitizer.bypassSecurityTrustHtml('-');
    return this.sanitizer.bypassSecurityTrustHtml(description.replace(/\n/g, '<br>'));
  }
  checkForSeanceReference() {
    this.route.params.subscribe(params => {
      // console.log(" Paramètres de la route :", params);
  
      if (params['reference']) {
        this.seanceReference = params['reference'];
        // console.log(" Référence trouvée via route :", this.seanceReference);
        this.loadSeanceByReference(this.seanceReference!); 
      } else {
        const url = window.location.href;
        // console.log(" URL brute :", url);
  
        if (url.includes('home/')) {
          this.seanceReference = this.extractSeanceReference(url);
          // console.log(" Référence extraite de l'URL :", this.seanceReference);
  
          if (this.seanceReference) {
            this.loadSeanceByReference(this.seanceReference);
          } else {
            console.warn(" Aucune référence trouvée dans l'URL brute.");
          }
        } else {
          console.warn(" L'URL ne contient pas 'seance/'");
        }
      }
    });
  }
  

  private checkGeolocationPermission(): Promise<boolean> {
    return new Promise((resolve) => {
      if (!navigator.permissions) {
        resolve(true); 
        return;
      }
  
      navigator.permissions.query({ name: 'geolocation' })
        .then(permissionStatus => {
          resolve(true);
          // if (permissionStatus.state === 'denied') {
          //   this.showUnblockInstructions();
          //   resolve(false);
          // } else {
          //   resolve(true);
          // }
  
          permissionStatus.onchange = () => {
            if (permissionStatus.state === 'granted') {
              this.hasValidLocation = true;
            }
          };
        })
        .catch(() => resolve(true)); // En cas d'erreur, on continue
    });
  }
  private showUnblockInstructions() {
    Swal.fire({
      title: 'Accès à la localisation bloqué',
      html: `
        <div class="text-left">
          <p class="mb-4">Vous avez bloqué l'accès à votre position. Pour confirmer votre présence, vous devez :</p>
          
          <div class="bg-gray-50 p-3 rounded-md mb-3">
            <h3 class="font-bold mb-1">Sur Chrome/Edge :</h3>
            <ol class="list-decimal pl-5 space-y-1">
              <li>Cliquez sur l'icône <svg class="inline w-4 h-4" viewBox="0 0 24 24"><path fill="currentColor" d="M12,15.5A3.5,3.5 0 0,1 8.5,12A3.5,3.5 0 0,1 12,8.5A3.5,3.5 0 0,1 15.5,12A3.5,3.5 0 0,1 12,15.5M19.43,12.97C19.47,12.65 19.5,12.33 19.5,12C19.5,11.67 19.47,11.34 19.43,11L21.54,9.37C21.73,9.22 21.78,8.95 21.66,8.73L19.66,5.27C19.54,5.05 19.27,4.96 19.05,5.05L16.56,6.05C16.04,5.66 15.5,5.32 14.87,5.07L14.5,2.42C14.46,2.18 14.25,2 14,2H10C9.75,2 9.54,2.18 9.5,2.42L9.13,5.07C8.5,5.32 7.96,5.66 7.44,6.05L4.95,5.05C4.73,4.96 4.46,5.05 4.34,5.27L2.34,8.73C2.21,8.95 2.27,9.22 2.46,9.37L4.57,11C4.53,11.34 4.5,11.67 4.5,12C4.5,12.33 4.53,12.65 4.57,12.97L2.46,14.63C2.27,14.78 2.21,15.05 2.34,15.27L4.34,18.73C4.46,18.95 4.73,19.03 4.95,18.95L7.44,17.94C7.96,18.34 8.5,18.68 9.13,18.93L9.5,21.58C9.54,21.82 9.75,22 10,22H14C14.25,22 14.46,21.82 14.5,21.58L14.87,18.93C15.5,18.67 16.04,18.34 16.56,17.94L19.05,18.95C19.27,19.03 19.54,18.95 19.66,18.73L21.66,15.27C21.78,15.05 21.73,14.78 21.54,14.63L19.43,12.97Z"/></svg> à droite de l'URL</li>
              <li>Sélectionnez "Paramètres du site"</li>
              <li>Dans "Permissions", cliquez sur "Localisation"</li>
              <li>Choisissez "Autoriser"</li>
            </ol>
          </div>
  
          <div class="bg-gray-50 p-3 rounded-md">
            <h3 class="font-bold mb-1">Sur Firefox :</h3>
            <ol class="list-decimal pl-5 space-y-1">
              <li>Cliquez sur l'icône <svg class="inline w-4 h-4" viewBox="0 0 24 24"><path fill="currentColor" d="M12,15.5A3.5,3.5 0 0,1 8.5,12A3.5,3.5 0 0,1 12,8.5A3.5,3.5 0 0,1 15.5,12A3.5,3.5 0 0,1 12,15.5M19.43,12.97C19.47,12.65 19.5,12.33 19.5,12C19.5,11.67 19.47,11.34 19.43,11L21.54,9.37C21.73,9.22 21.78,8.95 21.66,8.73L19.66,5.27C19.54,5.05 19.27,4.96 19.05,5.05L16.56,6.05C16.04,5.66 15.5,5.32 14.87,5.07L14.5,2.42C14.46,2.18 14.25,2 14,2H10C9.75,2 9.54,2.18 9.5,2.42L9.13,5.07C8.5,5.32 7.96,5.66 7.44,6.05L4.95,5.05C4.73,4.96 4.46,5.05 4.34,5.27L2.34,8.73C2.21,8.95 2.27,9.22 2.46,9.37L4.57,11C4.53,11.34 4.5,11.67 4.5,12C4.5,12.33 4.53,12.65 4.57,12.97L2.46,14.63C2.27,14.78 2.21,15.05 2.34,15.27L4.34,18.73C4.46,18.95 4.73,19.03 4.95,18.95L7.44,17.94C7.96,18.34 8.5,18.68 9.13,18.93L9.5,21.58C9.54,21.82 9.75,22 10,22H14C14.25,22 14.46,21.82 14.5,21.58L14.87,18.93C15.5,18.67 16.04,18.34 16.56,17.94L19.05,18.95C19.27,19.03 19.54,18.95 19.66,18.73L21.66,15.27C21.78,15.05 21.73,14.78 21.54,14.63L19.43,12.97Z"/></svg> à gauche de l'URL</li>
              <li>Cliquez sur "Paramètres de la page"</li>
              <li>Dans "Permissions", modifiez "Partager la localisation"</li>
              <li>Sélectionnez "Autoriser"</li>
            </ol>
          </div>
  
          <p class="mt-4 text-sm text-gray-500">Après avoir modifié ce paramètre, rafraîchissez la page.</p>
        </div>
      `,
      icon: 'info',
      confirmButtonText: 'J\'ai compris',
  showCancelButton: true,
  confirmButtonColor: '#ff7900',
              cancelButtonColor: '#d33',
              cancelButtonText: 'Non',
    }).then((result) => {
      if (result.isConfirmed) {
        //this.disableForm();
      }
    });
  }

  // Extraction de la référence depuis une URL
  extractSeanceReference(url: string): string | null {
    try {
      const urlParts = url.split('/');
      return urlParts[urlParts.length - 1];
    } catch (error) {
      console.error('Erreur lors de l\'extraction de la référence:', error);
      return null;
    }
  }

  onlyNumberKey(event: KeyboardEvent) {
    const charCode = (event.which) ? event.which : event.keyCode;
    // Seuls les chiffres 0-9 sont autorisés
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
    }
    return true;
  }

  // Chargement des détails de la séance
 loadSeanceByReference(referenceSeance: string) {
    this.loading = true;
    
    const requestData = {
      index: 0,
      size: 1,
      isSimpleLoading: false,
      user: 1,
      data: {
        referenceSeance: referenceSeance,
        isDeleted: false
      }
    };
  
    this.restClient
      .post('seance/getByCriteriaInvite', requestData)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.loading = false;
          this.cdr.markForCheck();
        })
      )
      .subscribe({
        next: (res: any) => {
          if (res?.item) { 
            const seanceDetails = res.item;  
            
            let ordreJourDisplay: string | any[];
            
            if (seanceDetails.isSeanceMultiple) {
              ordreJourDisplay = [];
            } else {
              ordreJourDisplay = seanceDetails.ordreDuJour 
                ? (Array.isArray(seanceDetails.ordreDuJour) 
                    ? seanceDetails.ordreDuJour 
                    : [seanceDetails.ordreDuJour])
                : [];
            }

            this.reunionInfo = {
              id: seanceDetails.id,
              titre: seanceDetails.libelle,
              date: seanceDetails.date || this.formatDate(seanceDetails.dateDebut),
              heureDebut: this.formatTime(seanceDetails.heureDebut),
              heureFin: this.formatTime(seanceDetails.heureFin),
              lieu: seanceDetails.lieu,
              description: seanceDetails.description,
              ordreJour: seanceDetails.obj,
              ordreDuJour: ordreJourDisplay, // Utilisation de la variable préparée
              organisateur: seanceDetails.organisateur
            };

            this.isSeanceMultiple = seanceDetails.isSeanceMultiple || false;
            
            if (this.isSeanceMultiple) {
              this.getOrdreJourForSpecificSeance(referenceSeance);
            }
          }
        },
        error: (err) => {
          // Gestion des erreurs
          console.error('Erreur lors du chargement de la séance:', err);
        }
      });
  }

  formatDate(dateString: string): string {
    if (!dateString) return '';
    
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  }

  formatTime(timeString: string): string {
    if (!timeString) return '';
    return timeString;
  }

  async getUserLocation() {
    const hasPermission = await this.checkGeolocationPermission();
    
    if (!hasPermission) {
      return;
    }
  
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
       
        (position) => {
          this.inscriptionForm.patchValue({
            longitudePresence: position.coords.longitude.toString(),
            latitudePresence: position.coords.latitude.toString()
          });
          this.hasValidLocation = true;
        },
        (error) => {
          if (error.code === error.PERMISSION_DENIED) {
          //  this.showUnblockInstructions();
          } else {
            // Autres erreurs
          }
        }
      );
    }
  }
  
  private requestLocationWithRetry(attempts = 0) {
    // console.log(' Tentative de récupération de la localisation. Attempt:', attempts + 1);
  
    const maxAttempts = 3;
  
    // if (!navigator.geolocation) {
    //   console.warn(' Géolocalisation non supportée par ce navigateur.');
    //   this.handleGeolocationError('unsupported');
    //   return;
    // }
  
    navigator.geolocation.getCurrentPosition(
      (position) => {
        // Succès
        const longitude = position.coords.longitude;
        const latitude = position.coords.latitude;
  
        console.log('✅ Localisation obtenue !');
        console.log('Longitude :', longitude);
        console.log('Latitude :', latitude);
  
        this.inscriptionForm.patchValue({
          longitudePresence: longitude.toString(),
          latitudePresence: latitude.toString()
        });
  
        this.hasValidLocation = true;
        this.utilitiesService.showNotification('Localisation enregistrée', 'success');
      },
      (error) => {
        // Échec
        // console.error('❌ Erreur de géolocalisation :', error);
        attempts++;
        if (attempts < maxAttempts) {
          // console.log(` Nouvelle tentative (${attempts + 1}/${maxAttempts})`);
          // this.handleGeolocationError(error.code, attempts, maxAttempts);
          this.requestLocationWithRetry(attempts);
        } else {
          console.warn(' Tentatives épuisées.');
          // this.handleGeolocationError(error.code);
         // this.disableForm();
        }
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      }
    );
  }
  
private handleGeolocationError(code: string | number, currentAttempt = 0, maxAttempts = 3) {
  let message = '';
  let showRetry = false;

  switch (code) {
    case 1: 
      message = 'Vous devez autoriser la géolocalisation pour confirmer votre présence.';
      showRetry = true;
      break;
    case 2: 
      message = 'Impossible d\'obtenir votre position. Vérifiez votre connexion.';
      showRetry = true;
      break;
    case 3: 
      message = 'Le temps d\'attente pour la localisation a expiré.';
      showRetry = true;
      break;
    case 'unsupported':
      message = 'Votre navigateur ne supporte pas la géolocalisation.';
      break;
    default:
      message = 'Erreur inconnue lors de l\'accès à votre position.';
      showRetry = true;
  }

  if (currentAttempt > 0) {
    message += ` (Tentative ${currentAttempt}/${maxAttempts})`;
  }

  Swal.fire({
    title: 'Localisation requise',
    text: message,
    icon: 'warning',
    showCancelButton: showRetry,
    confirmButtonText: showRetry ? 'Réessayer' : 'OK',
    cancelButtonText: 'Annuler',
    confirmButtonColor: '#ff7900'
  }).then((result) => {
    if (result.isConfirmed && showRetry) {
      this.requestLocationWithRetry(currentAttempt);
    } else if (!showRetry || result.dismiss) {
      //this.disableForm();
    }
  });
}
// private disableForm() {
//   this.inscriptionForm.disable();
//   this.hasValidLocation = false;
//   Swal.fire(
//     'Action impossible',
//     'La confirmation de présence nécessite votre localisation.',
//     'error'
//   );
// }

goToStep(step: number) {
  if (step > this.currentStep) {
    // Validation de l'email à l'étape 2
    if (this.currentStep === 2 && this.formControls['email'].invalid) {
      return;
    }

    if (this.currentStep === 4 && this.hasSignature) {
    this.signatureDataURL = this.canvasEl.nativeElement.toDataURL("image/png");
    this.signatureImage = new Image();
    this.signatureImage.src = this.signatureDataURL;
  }
    
    // Vérification de l'email avant de passer au step 3
    if (this.currentStep === 2 && step === 3) {
      if (!this.confidentialiteAcceptee) {
        Swal.fire(
          'Confidentialité requise',
          'Vous devez accepter les paramètres de confidentialité pour continuer.',
          'warning'
        );
        return;
      }
      this.verifyEmailBeforeStep3();
      return;
    }
    
    // Validation des informations personnelles à l'étape 3
    if (this.currentStep === 3 && 
      (this.formControls['prenoms'].invalid || this.formControls['nom'].invalid)) {
      return;
    }
    if (this.currentStep === 4 && this.hasSignature) {
    this.signatureDataURL = this.canvasEl.nativeElement.toDataURL("image/png");
    this.signatureImage = new Image();
    this.signatureImage.src = this.signatureDataURL;
  }
    // Validation de la signature à l'étape 4 avant de passer au récapitulatif
    // if (this.currentStep === 4 && step === 5) {
    //   if (!this.hasSignature) {
    //     Swal.fire(
    //       'Signature requise',
    //       'Vous devez signer avant de continuer.',
    //       'warning'
    //     );
    //     return;
    //   }
    //   // Sauvegarder automatiquement la signature
    //   this.signatureDataURL = this.canvasEl.nativeElement.toDataURL("image/png");
    // }
  }
  
  // Permettre la navigation entre les étapes 1 à 6
  if (step >= 1 && step <= 6) {
    this.currentStep = step;
  }
  
  // Setup du canvas pour l'étape 4
  if (step === 4) {
    setTimeout(() => {
      this.setupCanvas();
    }, 0);
  }
  
  this.cdr.markForCheck();
}
 closeRegistration() {
  // Fermeture directe possible
  if (typeof window !== 'undefined' && window.opener) {
    window.close();
    return;
  }

  // Tentative de fermeture pour les autres cas
  try {
    // Crée un état qui permet la fermeture
    window.open('', '_self', '');
    window.close();
  } catch (e) {
    // Redirection vers une page blanche
    window.location.href = 'about:blank';
    
    // Fermeture finale
    setTimeout(() => {
      try {
        window.close();
      } catch (finalError) {
        console.log("Impossible de fermer, redirection vers l'accueil");
        
      }
    }, 100);
  }
}
  //  closeRegistration() {
  //    // Option 1: Fermer la fenêtre/onglet
  //    window.close();
    
  // //   // Option 2: Rediriger vers une autre page
  // //   // this.router.navigate(['/accueil']);
    
  // //   // Option 3: Recharger la page pour une nouvelle inscription
  // //    window.location.reload();
    
  // //   // Option 4: Afficher un message ou ne rien faire
  // //   //console.log('Inscription terminée');
  //  }
//   closeRegistration() {
//   this.currentStep = 1;
//   this.inscriptionForm.reset();
//   this.clear(); 
// }

// Nouvelle méthode pour vérifier l'email avant le step 3
verifyEmailBeforeStep3() {
  const email = this.formControls['email'].value;
  
  if (!email || this.formControls['email'].invalid) {
    Swal.fire(
      'Email invalide',
      'Veuillez entrer une adresse email valide.',
      'warning'
    );
    return;
  }

  this.loading = true;
  
  const request = {
    user: 4,
    data: {
      email: email,
      // seanceId: this.reunionInfo.id
    }
  };
  
  this.restClient
    .post('presence/getParticipantInfo', request)
    .pipe(
      takeUntil(this.destroy$),
      finalize(() => {
        this.loading = false;
        this.cdr.markForCheck();
      })
    )
    .subscribe({
      next: (res: any) => {
        console.log('Réponse vérification email:', res);
        
        if (res && !res.hasError) {
          // Si l'email est valide et trouvé, on peut passer au step 3
          if (res.items && res.items.length > 0) {
            // Optionnel : pré-remplir les champs avec les informations trouvées
            const participantInfo = res.items[0];
            if (participantInfo) {
              this.inscriptionForm.patchValue({
                nom: participantInfo.nom || '',
                prenoms: participantInfo.prenoms || '',
                telephone: participantInfo.telephone || '',
                fonction: participantInfo.fonction || '',
                societe: participantInfo.societe || ''
              });
            }
          }
          
          // Passer au step 3
          this.currentStep = 3;
          this.cdr.markForCheck();
          
        } else {
          // Email non trouvé ou erreur
          Swal.fire({
            title: 'Email non reconnu',
            text: 'Cet email n\'est pas associé à cette réunion. Veuillez vérifier votre adresse email ou contacter l\'organisateur.',
            icon: 'warning',
            confirmButtonText: 'OK',
            confirmButtonColor: '#ff7900'
          });
        }
      },
      error: (err) => {
        console.error('Erreur lors de la vérification de l\'email:', err);
        
        Swal.fire({
          title: 'Erreur de vérification',
          text: 'Une erreur s\'est produite lors de la vérification de votre email. Veuillez réessayer.',
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#ff7900'
        });
      }
    });
}

// Modifiez également la méthode getInfo existante pour la rendre plus générique
getInfo(email: string) {
  const request = {
    user: 4,
    data: {
      email: email,
      // seanceId: this.reunionInfo.id
    }
  };
  
  return this.restClient
    .post('presence/getParticipantInfo', request)
    .pipe(
      takeUntil(this.destroy$)
    );
}

// goToStep(step: number) {
//   if (step === 4 && !this.hasValidLocation) {
//     Swal.fire(
//       'Localisation requise',
//       'Vous devez d\'abord autoriser l\'accès à votre position avant de signer.',
//       'warning'
//     );
//     return;
//   }

//   if (step > this.currentStep) {
//     if (this.currentStep === 2 && this.formControls['email'].invalid) {
     
//       return;
//     }
    
//     if (this.currentStep === 3 && 
//       (this.formControls['prenoms'].invalid || this.formControls['nom'].invalid)) {
//       return;
//     }
//   }
  
//   this.currentStep = step;
  
//   if (step === 4) {
//     setTimeout(() => {
//       this.setupCanvas();
//     }, 0);
//   }
  
//   this.cdr.markForCheck();
// }


//  getInfo(email: string) {
//     const request = {
//       user: 4,
//       data: {
//         email: email,
//         seanceId: this.reunionInfo.id
//       }
//     };
    
//     this.restClient
//       .post('presence/getParticipantInfo', request)
//       .pipe(
//         takeUntil(this.destroy$),
//         finalize(() => {
//           this.cdr.markForCheck();
//         })
//       )
//       .subscribe({
//         next: (res: any) => {
//           console.log('Réponse API Ordre du jour:', res);
          
//           if (res?.items?.length > 0) {
//             this.seances = res.items;
//             this.totalItems = res.count || res.items.length;
//           } else {
//             this.seances = [];
//             this.totalItems = 0;
//           }
//         },
//         error: (err) => {
//           console.error('Erreur lors de la récupération des informations du participant:', err);
//           this.seances = [];
//           this.totalItems = 0;
//         },
//       });
//   }
  

  get formControls(): { [key: string]: AbstractControl } {
    return this.inscriptionForm.controls;
  }

  setupCanvas() {
    const canvas = this.canvasEl?.nativeElement;
    if (!canvas) {
      console.error('Canvas element not found');
      return;
    }
    
    this.ctx = canvas.getContext('2d')!;
    
    this.resizeCanvas();
    window.addEventListener('resize', this.resizeCanvas.bind(this));

    this.ctx.lineWidth = 2;
    this.ctx.lineCap = 'round';
    this.ctx.lineJoin = 'round';
    this.ctx.strokeStyle = '#000000';

    this.setupEventListeners();
  }

  resizeCanvas() {
    const canvas = this.canvasEl?.nativeElement;
    if (!canvas) return;
    
    const rect = canvas.parentElement?.getBoundingClientRect();
    
    if (rect) {
      canvas.width = rect.width;
      canvas.height = 150;
      
      this.ctx.lineWidth = 2;
      this.ctx.lineCap = 'round';
      this.ctx.lineJoin = 'round';
      this.ctx.strokeStyle = '#000000';
    }
  }

  setupEventListeners() {
    const canvas = this.canvasEl.nativeElement;

    // Événements pour souris
    canvas.addEventListener('mousedown', this.startDrawing.bind(this));
    canvas.addEventListener('mousemove', this.draw.bind(this));
    canvas.addEventListener('mouseup', this.stopDrawing.bind(this));
    canvas.addEventListener('mouseout', this.stopDrawing.bind(this));

    // Événements pour écran tactile
    canvas.addEventListener('touchstart', this.startTouchDrawing.bind(this));
    canvas.addEventListener('touchmove', this.touchDraw.bind(this));
    canvas.addEventListener('touchend', this.stopDrawing.bind(this));
  }

  startDrawing(e: MouseEvent) {
    this.isDrawing = true;
    this.hasSignature = true;
    this.ctx.beginPath();
    this.ctx.moveTo(e.offsetX, e.offsetY);
  }

  draw(e: MouseEvent) {
    if (!this.isDrawing) return;
    this.ctx.lineTo(e.offsetX, e.offsetY);
    this.ctx.stroke();
  }

  startTouchDrawing(e: TouchEvent) {
    e.preventDefault();
    this.isDrawing = true;
    this.hasSignature = true;
    
    const touch = e.touches[0];
    const rect = this.canvasEl.nativeElement.getBoundingClientRect();
    const offsetX = touch.clientX - rect.left;
    const offsetY = touch.clientY - rect.top;
    
    this.ctx.beginPath();
    this.ctx.moveTo(offsetX, offsetY);
  }

  touchDraw(e: TouchEvent) {
    e.preventDefault();
    if (!this.isDrawing) return;
    
    const touch = e.touches[0];
    const rect = this.canvasEl.nativeElement.getBoundingClientRect();
    const offsetX = touch.clientX - rect.left;
    const offsetY = touch.clientY - rect.top;
    
    this.ctx.lineTo(offsetX, offsetY);
    this.ctx.stroke();
  }

  stopDrawing() {
    this.isDrawing = false;
  }
  clear() {
  const ctx = this.ctx;
  if (ctx) {
    ctx.clearRect(0, 0, this.canvasEl.nativeElement.width, this.canvasEl.nativeElement.height);
    this.hasSignature = false;
    this.signatureDataURL = null;
    this.signatureImage = null; // <-- Ajouté
  }
}

  // clear() {
  //   this.ctx.clearRect(0, 0, this.canvasEl.nativeElement.width, this.canvasEl.nativeElement.height);
  //   this.hasSignature = false;
  //    this.signatureImage = null;
  //   this.signatureDataURL = null;
  // }

  save() {
    if (this.hasSignature) {
      this.signatureDataURL = this.canvasEl.nativeElement.toDataURL("image/png");
    }
  }

  confirmSave() {
  if (!this.hasSignature) {
    Swal.fire(
      'Signature requise',
      'Vous devez signer avant de confirmer votre présence.',
      'warning'
    );
    return;
  }

  if (this.inscriptionForm.valid) {
    this.loading = true;
    
    const base64Data = this.signatureDataURL?.split(',')[1];

    const requestData = {
      user: 1,
      datas: [{
        seanceId: this.reunionInfo.id,
        ...this.inscriptionForm.value,
        signature: base64Data
      }]
    };
    
    Swal.fire({
      title: 'Confirmation',
      text: 'Vous êtes sur le point de confirmer votre présence à la réunion. Voulez-vous poursuivre cette action ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#ff7900',
      cancelButtonColor: '#000',
      confirmButtonText: 'Oui',
      cancelButtonText: 'Non',
    }).then((result) => {
      if (result.value) {
        console.log('Données envoyées:', requestData);
        
        const endpoint = 'presence/create';
        
        this.restClient
          .post(endpoint, requestData)
          .pipe(
            takeUntil(this.destroy$),
            finalize(() => {
              this.loading = false;
              this.cdr.markForCheck();
            })
          )
          .subscribe({
            next: (res) => {
              if (!res.hasError) {
                this.utilitiesService.showNotification(
                  'Présence enregistrée avec succès',
                  'success'
                );
                // Passer à l'étape de confirmation (step 6)
                this.currentStep = 6;
                this.cdr.markForCheck();
              } else {
                this.utilitiesService.showNotification(
                  res['status']?.message || "Une erreur s'est produite lors de l'enregistrement",
                  'error'
                );
                this.cdr.markForCheck();
              }
            },
            error: (err) => {
              console.error('Erreur:', err);
              this.utilitiesService.showNotification(
                "Une erreur inattendue s'est produite",
                'error'
              );
              this.cdr.markForCheck();
            },
          });
      } else {
        this.loading = false;
      }
    });
  }
}

  getCurrentStepTitle(): string {
  switch (this.currentStep) {
    case 1:
      return 'Informations Générales';
    case 2:
      return 'Email';
    case 3:
      return 'Informations personnelles';
    case 4:
      return 'Signature & validation';
    case 5:
      return 'Confirmation';
    default:
      return 'Étape inconnue';
  }
}
  
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    window.removeEventListener('resize', this.resizeCanvas.bind(this));
  }
}


 